import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, ValidatorFn } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContractorHotWorkPermitService {

  constructor(private httpClient: HttpClient,
    public fb: FormBuilder) { 

  }
  getHotWorkPermitFormDetails(){
    return this.fb.group({
      dateOfIssue: [''],
      siteOfWork: this.fb.array([
        {name: 'Production Area', value: 'Production Area', checked: false},
        {name: 'Storage Area', value: 'Storage Area', checked: false},
        {name: 'Utility', value: 'Utility', checked: false},
        {name: 'Other', value: 'Other', checked: false}
      ]),
      locationOfWork: [''],
      otherLocationOfWork: [''],
      columnNo: [''],
      scopeOfWork: [''],
      activitiesNeeded: this.fb.array([
        {name: 'Welding', value: 'Welding', checked: false},
        {name: 'Gas Cutting', value: 'Gas Cutting', checked: false},
        {name: 'Grinding', value: 'Grinding', checked: false},
        {name: 'Other', value: 'Other', checked: false}
      ]),
      nameOfContractor: [''],
      emailOfContractor: [''],
      mobileNoOfContractor: [''],
      contractAgency: [''],
      savwiplexecutingDept: [''],
      savwiplexecutivingDeptPerson: [''],
      savwiploperationDept: [''],
      savwiploperationDeptPerson: [''],
      status: [''],
      fromDate: [''],
      toDate: [''],
      fromTime: [''],
      toTime: [''],
      id: [''],
      hotWorkPermitNo: [''],
      remark: ['']
    })
  }
  getCWPFormDetails(){
    return this.fb.group({
      activitiesNeeded: this.fb.array([
        {name: 'Civil work', value: 'Civil work', checked: false},
        {name: 'Drilling', value: 'Drilling', checked: false},
        {name: 'Cutting', value: 'Cutting', checked: false},
        {name: 'Other', value: 'Other', checked: false}
      ]),
      coldWorkPermitNo: [''],
      columnNo: [''],
      contractAgency: [''],
      dateOfIssue: [''],
      emailOfContractor: [''],
      fileName: [''],
      fromDate: [''],
      fromTime: [''],
      id: [''],
      issuedBy: [''],
      isDraft: [''],
      locationOfWork: [''],
      mobileNoOfContractor: [''],
      nameOfContractor: [''],
      otherActivitiesNeeded: [''],
      otherLocationOfWork: [''],
      otherSiteOfWork:[''],
      remark: [''],
      savwiplexecutivingDeptPerson: [''],
      savwiplexecutingDept: [''],
      savwiploperationDept: [''],
      savwiploperationDeptPerson: [''],
      scopeOfWork: [''],
      siteOfWork: this.fb.array([
        {name: 'Production Area', value: 'Production Area', checked: false},
        {name: 'Storage Area', value: 'Storage Area', checked: false},
        {name: 'Utility', value: 'Utility', checked: false},
        {name: 'Other', value: 'Other', checked: false}
      ]),
      status: [''],
      toDate: [''],
      toTime: [''],
    })
  }
  getHazardDetails(){
    return this.fb.group({
      active: [true],
      answers: ['NA',Validators.required],
      assoHazardId: [0],
      preSafetyId: [0]
    })
  }
  getEquipmentDetails(){
    return this.fb.group({
      PPE: this.fb.array([
        {name: 'HOUSEKEEPING',value: 'HOUSEKEEPING',checked: false},
        {name: 'WELDING SHIELD', value: 'WELDING SHIELD', checked: false},
        {name: 'WELDING GLOVES', value: 'WELDING GLOVES', checked: false},
        {name: 'SAFETY HARNESS', value: 'SAFETY HARNESS', checked: false}
      ]),
      MISC: this.fb.array([
        {name: 'FLASH BACK ARRESTOR', value: 'FLASH BACK ARRESTOR', checked: false},
        {name: 'FIRE BLANKET/SHIELD', value: 'FIRE BLANKET/SHIELD', checked: false},
        {name: 'FIRE EXTINGUISHER', value: 'FIRE EXTINGUISHER', checked: false},
        {name: 'BARRICADE/TAPE', value: 'BARRICADE/TAPE', checked: false}
      ])
    })
  }
  getInspectionList(){
    return this.fb.array([
      {
        name: '1 HOUR',
        value: '1 HOUR',
        checked: false
      },
      {
        name: '4 HOURS',
        value: '4 HOURS',
        checked: false,
      }
    ]);
  }
  getLevelTestDetails(){
    return this.fb.group({
      lEL: [''],
      lELTime: [''],
      id: [null],
    })
  }
  getOxygenTestDetails(){
    return this.fb.group({
      oxygen: [''],
      oxygenRequired: [''],
      id: [null],
    })
  }
  getCoTestDetails(){
    return this.fb.group({
      co: [''],
      coTime: [''],
      id: [null],
    })
  }
  getH2sTestDetails(){
    return this.fb.group({
      h2s: [''],
      h2sTime: [''],
      id: [null],
    })
  }
  getHWPExtention(){
    return this.fb.group({
      day: [''],
      date: [''],
      shiftOrTime: [''],
      signature: [''],
      id: [null]
    })
  }
  getHotWorkPermitSignature() {
    return this.fb.group({
      date: [''],
      fileName: [''],
      id: [null],
      name: [''],
      userType: [''],
      signature: [null,[Validators.required]],
    })
  }
  getHotWorkPermitSignatureNotMandetory() {
    return this.fb.group({
      date: [''],
      fileName: [''],
      id: [null],
      name: [''],
      userType: [''],
      signature: [null],
    })
  }
  getRoundsObservationDetails(){
    return this.fb.group({
      day: [''],
      shift: [''],
      standByIfRequired: [''],
      observations: [''],
      remark: ['']
    });
  }
  getHotWorkPermitViolation(){
    return this.fb.group({
      id: [null],
      voilationPhoto: [''],
      violationDetails: [''],
    })
  }
  getHotWorkPermitViolationSignature(){
    return this.fb.group({
      contractor: this.getHotWorkPermitSignatureNotMandetory(),
      optDept: this.getHotWorkPermitSignatureNotMandetory(),
      exeDept: this.getHotWorkPermitSignatureNotMandetory(),
      fireSafetyDept: this.getHotWorkPermitSignatureNotMandetory(),
    })
  }
  getReport(){
    return this.fb.group({
      chechInTime: [null],
      chechOutTime: [null],
      checkIn: [true],
      date: [null],
      day: [''],
      fileName: [''],
      id: [null],
      signature: ['']
    })
  }
  requireCheckboxesToBeCheckedValidator(minRequired = 1): ValidatorFn {
    return function validate(formGroup: FormGroup) {
      let checked = 0;
      Object.keys(formGroup.controls).forEach(key => {
        const control = formGroup.controls[key];
        if (control.value === true) {
          checked++;
        }
      });
      if (checked < minRequired) {
        return {
          requireOneCheckboxToBeChecked: true,
        };
      }
      return null;
    };
  }
  callGetApiByID(relativeUrl,id):Observable<any>{
    return this.httpClient.get(environment.baseUrl + relativeUrl + "/" + id);
  }
  callGetApi(relativeUrl):Observable<any>{
    return this.httpClient.get(environment.baseUrl + relativeUrl);
  }
  uploadSign(relativeUrl: string, data: any) {
    return this.httpClient.post(environment.baseUrl + relativeUrl, data);
  }
  addOrUpdateWorkPermitContractor(relativeUrl: string, data: any) {
    return this.httpClient.post(environment.baseUrl + relativeUrl, data);
  }
}

